import { Navigate, Outlet } from 'react-router';

import { useOrgOwner } from '@/app/hooks/use-org-owner';
import { paths } from '@/config/paths';

export const OwnerOnlyRoute = () => {
  const { isOwner, isLoading } = useOrgOwner();

  if (isLoading) return null;

  if (!isOwner) {
    return <Navigate to={paths.app.settings.members.getHref()} replace />;
  }

  return <Outlet />;
};

export const SettingsIndexRedirect = () => {
  const { isOwner, isLoading } = useOrgOwner();

  if (isLoading) return null;

  return (
    <Navigate
      to={
        isOwner
          ? paths.app.settings.subscription.getHref()
          : paths.app.settings.members.getHref()
      }
      replace
    />
  );
};
